import { QA_ENVIRONMENT_POP_UP_BLOCKER_COOKIE } from './qa-environment-pop-up-blocker.service.constants';
import { ServiceBase } from './../ServiceBase';
import { IQAEnvironmentPopUpBlockerService } from './qa-environment-pop-up-blocker.service.interface';
const md5 = require('md5');

export class QAEnvironmentPopUpBlockerService extends ServiceBase implements IQAEnvironmentPopUpBlockerService {

    validatePassword(password) {
        if (md5(password) === this.services.configuration.servicesConfigs.QAEnvironmentPopUp.validationKey) {
            this._setCookie();
            return true;
        }
        return false;
    }

    private _setCookie() {
        let expirationDate:Date = new Date();
        expirationDate.setMonth(expirationDate.getMonth() + 3);
        this.services.cookies.createCookie(QA_ENVIRONMENT_POP_UP_BLOCKER_COOKIE, 'true', expirationDate);
    }

}